import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./FormularioViatico.css"; 
import API from "../api";

const FormularioViatico = () => {
  const { id_conductor } = useParams();
  const navigate = useNavigate();

  const [conductor, setConductor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [salida, setSalida] = useState("");
  const [destino, setDestino] = useState("");
  const [gasolina, setGasolina] = useState(0);
  const [tiempo, setTiempo] = useState(0);
  const [alimentacion, setAlimentacion] = useState(0);

  // 🔹 Cargar datos del conductor
  useEffect(() => {
    fetch(`${API}/conductor/${id_conductor}`)
      .then((res) => {
        if (!res.ok) throw new Error("No se pudo obtener el conductor");
        return res.json();
      })
      .then((data) => {
        setConductor(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error en fetch:", err);
        setError("No se pudo cargar el conductor");
        setLoading(false);
      });
  }, [id_conductor]);

  //  Calcular gasolina, tiempo y alimentación
  useEffect(() => {
    if (salida && destino) {
      let distancia = 0;

      if (salida === "Chimaltenango" && destino === "Escuintla") distancia = 120;
      if (salida === "Chimaltenango" && destino === "Huehuetenango") distancia = 180;
      if (salida === "Guatemala" && destino === "Escuintla") distancia = 110;
      if (salida === "Guatemala" && destino === "Huehuetenango") distancia = 210;

      let costoGasolina = distancia * 26;
      let horas = distancia / 40;
      let costoAlimentacion = horas > 4 ? 50 : 25;

      setGasolina(costoGasolina.toFixed(2));
      setTiempo(horas.toFixed(1));
      setAlimentacion(costoAlimentacion);
    }
  }, [salida, destino]);

  //  Guardar en BD
  const guardarViatico = () => {
    if (!salida || !destino) {
      alert("Debes seleccionar salida y destino");
      return;
    }

    const datos = { salida, destino, gasolina, tiempo, alimentacion };

    fetch(`${API}/asignar/${id_conductor}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datos),
    })
      .then((res) => res.json())
      .then((data) => {
        alert(data.message || "Viático asignado con éxito");
        navigate("/asignar");
      })
      .catch((err) => {
        console.error("Error guardando viático:", err);
        alert("No se pudo guardar el viático");
      });
  };

  // 🔹 Renderizado seguro
  if (loading) return <p className="loading">Cargando datos del conductor...</p>;
  if (error)
    return (
      <div className="error">
        <h2>{error}</h2>
        <button onClick={() => navigate("/asignar")}>Regresar</button>
      </div>
    );
  if (!conductor)
    return (
      <div className="error">
        <h2>No se encontró el conductor</h2>
        <button onClick={() => navigate("/asignar")}>Regresar</button>
      </div>
    );

  //  Si hay datos del conductor
  return (
    <div className="form-container">
      <h2>
        Asignar Viático a {conductor.Nombres} {conductor.Apellidos}
      </h2>

      <div className="card-conductor">
        <p><b>Teléfono:</b> {conductor.Telefono}</p>
        <p><b>DPI:</b> {conductor.Dpi}</p>
      </div>

      <div className="form-group">
        <label>Lugar de salida:</label>
        <select value={salida} onChange={(e) => setSalida(e.target.value)}>
          <option value="">-- Selecciona salida --</option>
          <option value="Chimaltenango">Chimaltenango</option>
          <option value="Guatemala">Guatemala</option>
        </select>
      </div>

      <div className="form-group">
        <label>Lugar de destino:</label>
        <select value={destino} onChange={(e) => setDestino(e.target.value)}>
          <option value="">-- Selecciona destino --</option>
          <option value="Escuintla">Escuintla</option>
          <option value="Huehuetenango">Huehuetenango</option>
        </select>
      </div>

      <div className="results">
        <h3>Resultados:</h3>
        <p> Gasolina estimada: <b>Q{gasolina}</b></p>
        <p> Tiempo estimado: <b>{tiempo} horas</b></p>
        <p> Alimentación: <b>Q{alimentacion}</b></p>
      </div>

      <div className="buttons">
        <button className="btn-guardar" onClick={guardarViatico}>
          Confirmar Asignación
        </button>
        <button
          className="btn-cancelar"
          onClick={() => navigate("/asignar")}
        >
          Cancelar
        </button>
      </div>
    </div>
  );
};

export default FormularioViatico;
